<h3> {{'FR.TITLE'|translate}}</h3>
<div class="center" *ngIf="environment && frConfig.environments[environment]">
  <div class="bz-space--stack-s">

  </div>
  <div class="bz-space--stack-s">
    <label for="frEndpoint" class="font-weight-bold">{{'FR.ENDPOINT'|translate}}</label>
    <bzg-input [(ngModel)]="frConfig.environments[environment].formsRecognizerEndpoint" id="frEndpoint"></bzg-input>
  </div>
  <div class="bz-space--stack-s">
    <label for="frKey" class="font-weight-bold">{{'FR.KEY'|translate}}</label>
    <bzg-input type="password" [(ngModel)]="frConfig.environments[environment].formsRecognizerKey" id="frKey"></bzg-input>
  </div>
  <div class="bz-space--stack-s">
    <label for="blobEndpoint" class="font-weight-bold">{{'FR.BLOB_ENDPOINT'|translate}}</label>
    <bzg-input  [(ngModel)]="frConfig.environments[environment].blobEndpoint" id="blobEndpoint"></bzg-input>
  </div>
  <div class="bz-space--stack-s">
    <label for="blobKey" class="font-weight-bold">{{'FR.BLOB_KEY'|translate}}</label>
    <bzg-input type="password" [(ngModel)]="frConfig.environments[environment].blobKey" id="blobKey"></bzg-input>
  </div>
  <div class="footer-buttons">
    <bzg-button-secondary class="bz-space--inline-s" (click)="cancelAction.emit(true)">{{'FR.CANCEL'|translate}}</bzg-button-secondary>
    <bzg-button-primary (click)="save()">{{'FR.SAVE'|translate}}</bzg-button-primary>
  </div>
</div>
